import { OnboardingPageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"
import { NightscoutContent } from "src/pages/Account/DataSource/Nightscout/NightscoutContent"

export function Nightscout() {
  const polyglot = usePolyglot()

  return (
    <OnboardingPageTemplate
      title={polyglot.t("components.page_header.pages.nightscout")}
      backRoutePath="/onboarding/data_source"
    >
      <NightscoutContent isOnboarding />
    </OnboardingPageTemplate>
  )
}
